import { inject, Injectable } from "@angular/core";
import { BaseDataService } from "app/core/services/base-data.service";
import { Lobby, LobbySearchParams, LobbySearchResults } from "../models/lobby.model";
import { API_MAP } from "app/core/helpers/api.map";
import { Observable, tap } from "rxjs";
import { Result } from "app/core/models/result";
import { ElasticsearchService } from "app/core/services/elasticsearch.service";
import { LanguageService } from "app/shared/services/language.service";
import { getLobbySortConfig } from "../mappers/sort-field.mapper";

@Injectable()
export class LobbyService extends BaseDataService<Lobby> {
    override controller = API_MAP.lobby;
    private readonly elasticSearchService = inject(ElasticsearchService);
    readonly currentLanguage = inject(LanguageService).currentLanguage;


    override get(controller?: string): Observable<Result<any>> {
        return super.get(controller ?? this.controller).pipe(
            tap((d: any) => {
                this.content.set(d.content);
                this.components.set(d.components);
            })
        );
    }

    getDataByIndex(index: string): Observable<LobbySearchResults> {
        var query = this.elasticSearchService.initQuery()
            .searchAll();
        return query.executeSearch([index]) as Observable<LobbySearchResults>;
    }

    searchLobby(index: string, params: LobbySearchParams, includeSearchTerm: boolean = true): Observable<LobbySearchResults> {
        const queryBuilder = this.elasticSearchService.initQuery();

        if (includeSearchTerm && params.searchField) {
            queryBuilder.searchAllFieldsByPartialTerm(params.searchField);
        }

        if (index.includes('event_index')) {
            queryBuilder.filterByDateAfter('endDate')
        }

        const reservedKeys = ['term', 'searchField', 'skip', 'take'];

        Object.entries(params).forEach(([key, value]) => {
            if (!reservedKeys.includes(key)) {
                queryBuilder.filterByFieldValues(key, value);
            }
        });
        
        const hasSearchText = includeSearchTerm && !!params.searchField?.trim();
        const sortConfig = getLobbySortConfig(index, hasSearchText);

        queryBuilder.addPagination();

        return queryBuilder.executeSearch([index], undefined, sortConfig) as Observable<LobbySearchResults>;
    }

}